module.exports = __webpack_public_path__ + "img/GOPAY.4f834fd2.svg";